// extracted by mini-css-extract-plugin
export default {"items":"items_items__HQnFw","hidden":"items_hidden__qs2tn","itemPagination":"items_itemPagination__aBFv2"};